import m from 'mithril'

const transitionDuration = 500

const transitionFunction = (scene, options = {}) => {
  const defaults = {
    fov: 1.027117024737278
  }
  const opts = { ...defaults, ...options }

  return new Promise((resolve, reject) => {
    scene.lookTo(
      { yaw: opts.yaw, pitch: opts.pitch, fov: opts.fov },
      { transitionDuration },
      () => {
        resolve()
      }
    )
  })
}

export default [
  {
    id: 'outside',
    source: require('panorama/images/01-outside-01.jpg'),
    // preload: ['tunnel-entrance'],
    orientation: {
      fov: 1.127117024737278,
      yaw: -1.7826346951677454,
      pitch: -0.12646086305945126
    },
    template: require('panorama/templates/PanoTitle').default,
    onVisible: function(viewer, scene) {
      let state = this

      state.trackList.forEach(track => {
        track.sound.fade(track.sound.volume(), 1, 2000)
      })

      state.autorotateTimer = setTimeout(() => {
        viewer.startMovement(state.autorotate)
        viewer.setIdleMovement(3000, state.autorotate)
      }, 3000)
    },
    onChange: function(viewer, scene) {
      let state = this

      // Get the current yaw.
      let yaw = viewer
        .scene()
        .view()
        .yaw()

      // Stop the autorotation of the first scene.
      if (yaw >= 0.7083794573090678 && yaw < -1.7826346951677454) {
        viewer.stopMovement()
      }
    },
    audio: [
      {
        id: 'outside',
        src: require('panorama/audio/outside.mp3'),
        volume: 0.05
      },
      // {
      //   id: 'flag',
      //   src: require('panorama/audio/flags.mp3'),
      //   volume: 0.05,
      //   position: -1.7784907380894897
      // }
    ],
    hotspots: [
      {
        id: 'outside-nav-tunnel-entrance-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        heading: 'Camp Century',
        portalHeight: 150,
        yaw: 0.7083794573090678,
        pitch: 0,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.6746227336266823,
            pitch: 0.004752108272827016,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-entrance')
          })
        }
      },
      {
        id: 'outside-text-2',
        template: require('panorama/components/Hotspot/templates/TitleHotspot').default,
        html: 'Grønland, 1962',
        yaw: -1.7826346951677454,
        pitch: -0.12646086305945126,
        depth: 500
      },
      {
        id: 'outside-text-1',
        template: require('panorama/components/Hotspot/templates/TitleHotspot').default,
        html: '1300 km til Nordpolen',
        yaw: -0.8382276331536644,
        pitch: -0.12646086305945126,
        depth: 500
      },
      {
        id: 'outside-video-atutak',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: '"Natuk"<br/>Medlem af Thulefolket<br/>Alder: Ukendt<br/>Forfædre har boet her siden 1200-tallet"',
        labelOffset: 50,
        yaw: -0.27144530840082837,
        pitch: -0.01,
        style: {
          width: '100px',
          height: '200px'
        },
        path: '/pano/outside?overlay=outside-video-atutak'
      },
    ]
  },
  {
    id: 'tunnel-entrance',
    source: require('panorama/images/02-tunnel-entrance-01.jpg'),
    // preload: ['outside', 'tunnel-recroom'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 2.714669089242891,
      pitch: 0.03073129964509036
    },
    audio: [
      {
        id: 'tunnel-audio',
        src: require('panorama/audio/tunnel-audio-01.mp3')
      }
    ],
    onInit: function(viewer, scene, options = {}) {
      let state = this

      //  Opens LogBook on first view (checks local storage) ------------------
      if (options.firstView) {
        setTimeout(() => {
          m.redraw()
        }, 100)
      }
    },
    hotspots: [
      {
        id: 'tunnel-entrance-nav-outside-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Udenfor',
        yaw: 0.002917327230886002,
        pitch: 0.25,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.002917327230886002,
            pitch: -0.013079644694412806,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/outside?y=3.14')
          })
        }
      },
      {
        id: 'tunnel-entrance-nav-tunnel-recroom-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Fællesrum',
        yaw: 3.123992782354035,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.123992782354035,
            pitch: -0.0013529266126433015,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-recroom')
          })
        }
      },
      {
        id: 'tunnel-entrance-tuk',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Tuk Erik Jørgen-Jensen<br>Dansk agent for Forsvarets Efterretningstjeneste<br>Øgenavn: Manden uden skygge<br>Alder: 27<br>Mission: At observere og rapportere',
        labelOffset: 30,
        yaw: 2.4112282465498254,
        pitch: 0.1794481292979313,
        style: {
          width: '109px',
          height: '335px'
        },
        path: '/pano/tunnel-entrance?overlay=tunnel-entrance-video-tuk'
      },
      // {
      //   id: 'tunnel-entrance-locked-labratories',
      //   template: require('panorama/components/Hotspot/templates/LockedHotspot').default,
      //   locked: true,
      //   text: 'Trench 11<br>Laboratories<br>(LOCKED)',
      //   yaw: -2.457010726162636,
      //   pitch: 0.06115838813157204
      // },
      // {
      //   id: 'tunnel-entrance-locked-theater',
      //   template: require('panorama/components/Hotspot/templates/LockedHotspot').default,
      //   locked: true,
      //   text: 'Trench 16<br>Theater<br>(LOCKED)',
      //   yaw: 1.25194734224646,
      //   pitch: 0.09346172495726535
      // }
    ]
  },
  {
    id: 'tunnel-recroom',
    source: require('panorama/images/03-tunnel-recroom-02.jpg'),
    // preload: ['tunnel-entrance', 'tunnel-quarters', 'recroom1'],
    orientation: {
      fov: 1.127117024737278,
      yaw: -2.6534527862508526,
      pitch: 0.08754519061206523
    },
    onInit: function(viewer, scene, options = {}) {
      let state = this

      let lastViewed = state.lastViewed.length - 2

      // Opens LogBook if you last viewed the recroom scene ------------------
      if (state.lastViewed[lastViewed] === "recroom1") {
        setTimeout(() => {
          m.route.set("/pano/tunnel-recroom?overlay=recroom-leave")
          m.redraw()
        }, 100)
      }

    },
    audio: [
      {
        id: 'tunnel-audio',
        src: require('panorama/audio/tunnel-audio-01.mp3')
      }
    ],
    hotspots: [
      {
        id: 'tunnel-recroom-nav-tunnel-entrance-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Indgang',
        yaw: 0.002917327230886002,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.002917327230886002,
            pitch: -0.013079644694412806,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-entrance?y=0.05')
          })
        }
      },
      {
        id: 'tunnel-recroom-nav-tunnel-quarters-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Beboelse',
        yaw: 3.123992782354035,
        pitch: 0.3,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.123992782354035,
            pitch: -0.0013529266126433015,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-quarters')
          })
        }
      },
      {
        id: 'tunnel-recroom-sign-recroom-locked-portal',
        template: require('panorama/components/Hotspot/templates/LockedHotspot').default,
        locked: false,
        text: '<p style="font-family: \'Futura Round Demi\'">TUNNEL 9<br>FÆLLESRUM</p>',
        yaw: -1.847752364425471,
        pitch: 0.057904671448335776,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -2.206195286441364,
            pitch: -0.034804568955692616,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/recroom1')
          })
        }
      },
      {
        id: 'tunnel-recroom-audio-tuk',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Tuk Erik Jørgen-Jensen<br>Dansk agent for Forsvarets Efterretningstjeneste<br>Øgenavn: Manden uden skygge<br>Alder: 27<br>Mission: At observere og rapportere',
        labelOffset: 30,
        yaw: -2.5722312815641857,
        pitch: 0.18536141012652593,
        style: {
          width: '109px',
          height: '335px'
        },
        path: '/pano/tunnel-recroom?overlay=tunnel-recroom-audio-tuk'
      },
    ]
  },
  {
    id: 'recroom1',
    source: require('panorama/images/04-recroom-01.jpg'),
    // preload: ['tunnel-recroom', 'recroom2'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 2.757868203650805,
      pitch: 0.24585191558983333
    },
    onInit: function(viewer, scene, options = {}) {
      let state = this

      //  Opens LogBook on first view (checks local storage) ------------------
        setTimeout(() => {
          m.route.set("/pano/recroom1?overlay=recroom-entrance")
          m.redraw()
        }, 100)
    },
    audio: [
      {
        id: 'recroom',
        src: require('panorama/audio/recroom.mp3'),
        volume: 0.5
      },
      // {
      //   id: 'recroom-audio-2',
      //   src: require('panorama/audio/tunnel-audio-01.mp3'),
      //   position: -0.3265982082500649,
      //   volume: 0.1
      // }
    ],
    hotspots: [
      {
        id: 'recroom1-nav-tunnel-recroom-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Udgang',
        yaw: -0.2936530060917306,
        pitch: 0.35,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -0.29557828678090914,
            pitch: 0.1286772717931406,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-recroom')
          })
        }
      },
      // {
      //   id: 'recroom1-nav-recroom2',
      //   template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
      //   text: '',
      //   yaw: 2.973365473224108,
      //   pitch: 0.3,
      //   click: (viewer, scene) => {
      //     transitionFunction(scene, {
      //       yaw: 2.973365473224108,
      //       pitch: 0.1286772717931406,
      //       fov: 0.5
      //     }).then(() => {
      //       m.route.set('/pano/recroom2')
      //     })
      //   }
      // },
      {
        id: 'recroom1-soren1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        text: 'Søren Gregernsen:<br>Dansk spejder<br>Alder: 19 år<br>6 måneder i Camp Century over 3 perioder<br>Mission: At måle tunneller. Inviteret af USA.',
        labelOffset: 0,
        yaw: 0.7706422197318719,
        pitch: 0.22667295537226906,
        style: {
          width: '100px',
          height: '100px'
        },
         //   path: '/pano/recroom1?overlay=recroom-video-poldi1'
      },
      {
        id: 'recroom1-video-soren1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Brusebad hver dag',
        labelOffset: 91,
        yaw: 0.7806422197318719,
        pitch: 0.22667295537226906,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/recroom1?overlay=recroom-video-soren1'
      },
      {
        id: 'recroom1-video-soren2',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'To verdener',
        labelOffset: 89,
        horizontalLabelOffset: 150,
        yaw: 0.7806422197318719,
        pitch: 0.22667295537226906,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/recroom1?overlay=recroom-video-soren2'
      },
      {
        id: 'recroom1-poldi',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        text: 'Menig Poldi<br>Fra West Point Militærakademi, årgang 55<br>Alder: 20 år<br>To måneder i Camp Century',
        labelOffset: 0,
        yaw: 2.08046718169802,
        pitch: 0.18057886758822939,
        style: {
          width: '100px',
          height: '100px'
        },
         //   path: '/pano/recroom1?overlay=recroom-video-poldi1'
      },
      // {
      //   id: 'recroom1-video-poldi1',
      //   template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
      //   icon: 'video',
      //   text: 'Menig Poldi<br>Fra West Point Militærakademi, årgang 55<br>Alder: 20 år<br>To måneder i Camp Century',
      //   labelOffset: 0,
      //   yaw: 2.08046718169802,
      //   pitch: 0.18057886758822939,
      //   style: {
      //     width: '100px',
      //     height: '100px'
      //   },
      //   path: '/pano/recroom1?overlay=recroom-video-poldi1'
      // },
      {
        id: 'recroom1-video-poldi1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Truslen fra<br>Sovjet',
        labelOffset: 78,
        yaw: 2.08546718169802,
        pitch: 0.18057886758822939,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/recroom1?overlay=recroom-video-poldi1'
      },
      {
        id: 'recroom1-video-poldi2',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Iceworms',
        labelOffset: 76,
        horizontalLabelOffset: 130,
        yaw: 2.08546718169802,
        pitch: 0.18057886758822939,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/recroom1?overlay=recroom-video-poldi2'
      },
      {
        id: 'recroom1-video-freeman',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Joseph Freeman<br>General og ingeniør, den amerikanske hær<br>Alder: 40<br>Mission: At lede Camp Century',
        labelOffset: 0,
        yaw: -2.9677645482299653,
        pitch: 0.10755956414487144,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/recroom1?overlay=recroom-video-freeman'
      },
      {
        id: 'recroom-video-projector',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Film om Camp Century',
        labelOffset: 0,
        yaw: 2.8608165139615025,
        pitch: 0.42215090486895335,
        style: {
          width: '50px',
          height: '100px'
        },
         path: '/pano/recroom1?overlay=recroom-video-projector'
      },
    ]
  },
  // {
  //   id: 'recroom2',
  //   source: require('panorama/images/04-recroom-02.jpg'),
  //   // preload: ['recroom1'],
  //   orientation: {
  //     fov: 1.127117024737278,
  //     yaw: -0.37471747519883536,
  //     pitch: 0.15254283681159464
  //   },
  //   audio: [
  //     {
  //       id: 'recroom-audio-1',
  //       src: require('panorama/audio/banquet-hall-interior.mp3'),
  //       volume: 0.5
  //     },
  //     {
  //       id: 'recroom-audio-2',
  //       src: require('panorama/audio/tunnel-audio-01.mp3'),
  //       position: -0.3265982082500649,
  //       volume: 0.1
  //     },
  //   ],
  //   hotspots: [
  //     {
  //       id: 'recroom2-nav-recroom1',
  //       template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
  //       text: '',
  //       yaw: 2.856210563089533,
  //       pitch: 0.35,
  //       click: (viewer, scene) => {
  //         transitionFunction(scene, {
  //           yaw: 2.891941018637384,
  //           pitch: 0.08115875857826182,
  //           fov: 0.5
  //         }).then(() => {
  //           m.route.set('/pano/recroom1?y=-0.28394081083404643')
  //         })
  //       }
  //     },
  //     {
  //       id: 'recroom2-video-projector',
  //       template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
  //       icon: 'video',
  //       text: 'Projector Video',
  //       labelOffset: 0,
  //       yaw: 2.9912331089954742,
  //       pitch: 0.11770179908654654,
  //       style: {
  //         width: '50px',
  //         height: '100px'
  //       },
  //       // path: '/pano/recroom2?overlay=???'
  //     },
  //   ]
  // },
  {
    id: 'tunnel-quarters',
    source: require('panorama/images/05-tunnel-quarters.jpg'),
    // preload: ['tunnel-recroom', 'tunnel-headquarters', 'quarters1'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 3.135550476707298,
      pitch: 0.010929619633801124
    },
    onInit: function(viewer, scene, options = {}) {
      var state = this;
      let lastViewed = state.lastViewed.length - 2

        // Opens LogBook if you last viewed the recroom scene ------------------
        if (state.lastViewed[lastViewed] === "quarters1") {
          setTimeout(() => {
            m.route.set("/pano/tunnel-quarters?overlay=quarters-leave")
            m.redraw()
          }, 100)
        }
    },
    audio: [{
      id: 'tunnel-audio',
      src: require('panorama/audio/tunnel-audio-01.mp3')
    }],
    hotspots: [
      {
        id: 'tunnel-quarters-nav-tunnel-recroom-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Fællesrum',
        yaw: 0.002917327230886002,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.002917327230886002,
            pitch: -0.013079644694412806,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-recroom?y=-0.0017565423691685567')
          })
        }
      },
      {
        id: 'tunnel-quarters-nav-tunnel-headquarters-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Kommandocentral',
        yaw: 3.123992782354035,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.123992782354035,
            pitch: -0.0013529266126433015,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-headquarters')
          })
        }
      },
      {
        id: 'tunnel-quarters-sign-quarters-locked-portal',
        template: require('panorama/components/Hotspot/templates/LockedHotspot').default,
        locked: false,
        text: 'Tunnel 19<br>Beboelse',
        yaw: 2.300366075588382,
        pitch: 0.022913995729712866,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 2.449548763276086,
            pitch: -0.03955468721907707,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/quarters1')
          })
        }
      },
      {
        id: 'tunnel-quarters-sign-gym-locked-portal',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        locked: false,
        text: 'Motionsrummet er lukket.<br> Vi viser film i aften istedet. ',
        labelOffset: 20,
        yaw: -2.358072889798379,
        pitch: 0.015657247031398924,
        path: '/pano/tunnel-quarters?overlay=tunnel-quarters-movienight'
      },
    ]
  },
  {
    id: 'quarters1',
    source: require('panorama/images/06-quarters-01.jpg'),
    // preload: ['tunnel-quarters', 'quarters2'],
    orientation: {
      fov: 1.127117024737278,
      yaw: -2.9249704534373073,
      pitch: 0.25971507333064814
    },
    onInit: function(viewer, scene, options = {}) {
      let state = this
      let lastViewed = state.lastViewed.length - 2
      if (state.lastViewed[lastViewed] === "tunnel-quarters") {
        setTimeout(() => {
          m.route.set("/pano/quarters1?overlay=quarters-entrance")
          m.redraw()
        }, 200)     
      } 
    },
    audio: [{
      id: 'quarters-audio',
      src: require('panorama/audio/quartersloop.mp3')
    }],
    hotspots: [
      {
        id: 'quarters1-nav-tunnel-quarters-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Udgang',
        yaw: -0.13415122546074286,
        pitch: 0.42,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -0.1209782599488527,
            pitch: 0.10428971730782699,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-quarters')
          })
        }
      },
      {
        id: 'quarters1-nav-quarters2-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: '',
        yaw: 3.0095776431880914,
        pitch: 0.33,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.0493102887152137,
            pitch: 0.09072976536271327,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/quarters2')
          })
        }
      },
      {
        id: 'quarters-soren1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        text: 'Søren Gregernsen:<br>Dansk spejder<br>Alder: 19 år<br>6 måneder i Camp Century over 3 perioder<br>Mission: At måle tunneller. Inviteret af USA.',
        labelOffset: 0,
        yaw: -2.511270708319577,
        pitch: 0.15985250848878138,
        style: {
          width: '100px',
          height: '100px'
        },
         //   path: '/pano/recroom1?overlay=recroom-video-poldi1'
      },
      {
        id: 'quarters-video-soren1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Benfigurer',
        labelOffset: 90,
        yaw: -2.511270708319577,
        pitch: 0.15985250848878138,
        style: {
          width: '100px',
          height: '100px'
        },
         path: '/pano/quarters1?overlay=quarters-video-soren1'
      },
      {
        id: 'quarters-video-soren2',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: '100 kilometer væk',
        labelOffset: 88,
        horizontalLabelOffset: 125,
        yaw: -2.511270708319577,
        pitch: 0.15985250848878138,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/quarters1?overlay=quarters-video-soren2'
      },
      {
        id: 'quarters1-book',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'document',
        text: 'Heinz Haber: “Vor ven atomet”, 1958',
        labelOffset: 0,
        yaw: 0.1021859455935288,
        pitch: 0.5099811276231137,
        style: {
          width: '60px',
          height: '60px'
        },
        // click: function(viewer, scene) {
        //   let state = this
        //   state.toggleLogBook(19)
        // }
        path: '/pano/quarters1?overlay=quarters1-book'
      },
      {
        id: 'quarters1-clock',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'document',
        text: 'Sørens vækkeur',
        labelOffset: '-17.5',
        yaw: -1.6658862829215195,
        pitch: 0.3615301095775081,
        style: {
          width: '20px',
          height: '20px'
        },
        path: '/pano/quarters1?overlay=quarters1-clock'
      },
      {
        id: 'quarters1-inuit-video',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Afrejsen. Medlem af Thulefolket, Natuk, fortæller',
        labelOffset: 0,
        yaw: 2.2336644651121134,
        pitch: 0.03966371592508011,
        style: {
          width: '40px',
          height: '60px'
        },
        path: '/pano/quarters1?overlay=quarters1-inuit-video'
      },
    ]
  },
  {
    id: 'quarters2',
    source: require('panorama/images/06-quarters-02.jpg'),
    // preload: ['quarters1'],
    orientation: {
      fov: 1.127117024737278,
      yaw: -0.02672255797978984,
      pitch: 0.14186028479905843
    },
    audio: [{
      id: 'quarters-audio',
      src: require('panorama/audio/quartersloop.mp3')
    }],
    hotspots: [
      {
        id: 'quarters2-nav-quarters1-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: '',
        yaw: 3.0095776431880914,
        pitch: 0.33,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.0493102887152137,
            pitch: 0.09072976536271327,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/quarters1?y=-0.12690823634269854')
          })
        }
      },
      // {
      //   id: 'quarters2-soren',
      //   template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
      //   icon: 'video',
      //   text: 'Søren Gregersen<br/>Dansk spejder<br/>Alder: 19 år<br/>6 måneder i Camp Century over 3 perioder<br/>Mission: At måle tunneller. Inviteret af USA.',
      //   labelOffset: 0,
      //   yaw: 2.180646927651515,
      //   pitch: 0.15324730725482482,
      //   style: {
      //     width: '60px',
      //     height: '200px'
      //   },
      //   // path: '/pano/quarters2?overlay=???'
      // },
      {
        id: 'quarters-video-poldi',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Menig Poldi<br>Fra West Point Militærakademi, årgang 55<br>Alder: 20 år<br>To måneder i Camp Century',
        labelOffset: 0,
        yaw: 0.09790700600211721,
        pitch: 0.26990435055728796,
        style: {
          width: '60px',
          height: '180px'
        },
         path: '/pano/quarters2?overlay=quarters-video-poldi'
      },
      {
        id: 'quarters2-inuit-video',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'De nye huse. Medlem af Thulefolket, Natuk, fortæller',
        labelOffset: 0,
        yaw: -1.3476758575839085,
        pitch: 0.005202496580084315,
        style: {
          width: '60px',
          height: '60px'
        },
        path: '/pano/quarters2?overlay=quarters2-inuit-video'
      },
      {
        id: 'quarters-soren1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        text: 'Søren Gregernsen:<br>Dansk spejder<br>Alder: 19 år<br>6 måneder i Camp Century over 3 perioder<br>Mission: At måle tunneller. Inviteret af USA.',
        labelOffset: 0,
        yaw: 2.421090195998115,
        pitch: 0.10228990915451064,
        style: {
          width: '100px',
          height: '100px'
        },
         //   path: '/pano/recroom1?overlay=recroom-video-poldi1'
      },
      {
        id: 'quarters2-video-soren1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Benfigurer',
        labelOffset: 90,
        yaw: 2.421090195998115,
        pitch: 0.10228990915451064,
        style: {
          width: '100px',
          height: '100px'
        },
         path: '/pano/quarters2?overlay=quarters-video-soren1'
      },
      {
        id: 'quarters2-video-soren2',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: '100 kilometer væk',
        labelOffset: 88,
        horizontalLabelOffset: 125,
        yaw: 2.421090195998115,
        pitch: 0.10228990915451064,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/quarters2?overlay=quarters-video-soren2'
      },
    ]
  },
  {
    id: 'tunnel-headquarters',
    source: require('panorama/images/07-tunnel-headquarters.jpg'),
    // preload: ['tunnel-quarters', 'tunnel-doctor', 'headquarters1'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 3.1377160185704227,
      pitch: -0.019024001916392308
    },
    audio: [{
      id: 'tunnel-audio',
      src: require('panorama/audio/tunnel-audio-01.mp3')
    }],

    onInit: function(viewer, scene, options = {}) {
      // On loading this scene, check the array of previously visited scenes.
      // If the list includes reactor1 & rails1, set the unlockHQ value to true.
      let state = this
      let lastViewed = state.lastViewed.length - 2
      if (state.lastViewed[lastViewed] === "headquarters1") {
        setTimeout(() => {
        m.route.set("/pano/tunnel-headquarters?overlay=hq-leave")
        m.redraw()
      }, 200)
    }
      if (state.viewedScenes.includes("reactor1") && state.viewedScenes.includes("rails1")) {
        // console.log("You have been to the Reactor and Rails.")
        viewer.unlockHQ = true
        scene.hotspots[2].locked = false
        scene.hotspots[2].text = 'Tunnel 20<br>Kommandocentral'
      } else {
        // console.log("You have not been to the Reactor and Rails.")
        viewer.unlockHQ = false
      }
    },
    hotspots: [
      {
        id: 'tunnel-headquarters-nav-tunnel-quarters-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Beboelse',
        yaw: 0.002917327230886002,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.002917327230886002,
            pitch: -0.013079644694412806,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-quarters?y=-0.0017565423691685567')
          })
        }
      },
      {
        id: 'tunnel-headquarters-nav-tunnel-doctor-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Reaktorrum',
        yaw: 3.1333221188288167,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.1364182219631775,
            pitch: -0.008624595678494273,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-doctor')
          })
        }
      },
      {
        id: 'tunnel-headquarters-sign-headquarters-locked-portal',
        template: require('panorama/components/Hotspot/templates/LockedHotspot').default,
        locked: false,
        text: 'Tunnel 20<br>Kommandocentral',
        yaw: 2.5397551545565165,
        pitch: 0.04227510436648174,
        locked: true,
        click: (viewer, scene, options) => {
          // On click, check the unlockHQ value. If true, change the scene.
          if (viewer.unlockHQ === true) {
            transitionFunction(scene, {
              yaw: 2.7265839890343813,
              pitch: 0.010875878805236994,
              fov: 0.5
            }).then(() => {
              m.route.set('/pano/headquarters1')
            })
          } else {
            m.route.set('/pano/tunnel-headquarters?overlay=hq-locked')
          }
        }
      },
      {
        id: 'tunnel-headquarters-video-tuk',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Søren Gregersen<br/>Dansk spejder<br/>Alder: 19 år<br/>6 måneder i Camp Century over 3 perioder<br/>Mission: At måle tunneller. Inviteret af USA.',
        labelOffset: 50,
        yaw: 2.262496988698123,
        pitch: 0.24454261312972392,
        style: {
          width: '90px',
          height: '250px'
        },
        path: '/pano/tunnel-headquarters?overlay=tunnel-headquarters-video-tuk'
      },
    ]
  },
  {
    id: 'headquarters1',
    source: require('panorama/images/08-headquarters-01.jpg'),
    // preload: ['tunnel-headquarters', 'headquarters2'],
    orientation: {
      fov: 1.127117024737278,
      yaw: -0.9127289993598335,
      pitch: 0.296310570189231
    },
    onInit: function(viewer, scene, options = {}) {
      let state = this
      let lastViewed = state.lastViewed.length - 2
      if (state.lastViewed[lastViewed] === "tunnel-headquarters") {
        setTimeout(() => {
          m.route.set("/pano/headquarters1?overlay=hq-entrance");
          m.redraw()
        }, 200)
      }
    },
    audio: [{
      id: 'hq-audio',
      src: require('panorama/audio/hq.mp3')
    }],
    hotspots: [
      {
        id: 'headquarters1-nav-tunnel-headquarters',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Udgang',
        yaw: -2.577265368494528,
        pitch: 0.37,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -2.5816584243405565,
            pitch: 0.09867237267388873,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-headquarters')
          })
        }
      },
      {
        id: 'headquarters1-nav-headquarters2-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: '',
        yaw: 0.1499269537001706,
        pitch: 0.39,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -0.049719225713511506,
            pitch: 0.10273837639313399,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/headquarters2')
          })
        }
      },
      {
        id: 'headquarters1-video-general',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Joseph Freeman<br/>General og ingeniør, den amerikanske hær<br/>Alder: 40<br/>Mission: At lede Camp Century',
        labelOffset: 30,
        // labelClasses: 'mod-texture-flip-x mod-texture-flip-y',
        yaw: -1.5605481170241688,
        pitch: 0.1754173163854997,
        style: {
          width: '100px',
          height: '200px'
        },
         path: '/pano/headquarters1?overlay=headquarters1-video-general'
      },
      {
        id: 'headquarters1-major1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'document',
        text: 'William Heat<br>Oversergent, den amerikanske hær<br>Alder: 48<br>Mission: At realisere Project Iceworm',
        labelOffset: 30,
        // labelClasses: 'mod-texture-flip-x mod-texture-flip-y',
        yaw:  -0.5469416371396534,
        pitch: 0.05729628577011425,
        style: {
          width: '70px',
          height: '100px'
        },
        // path: '/pano/headquarters1?overlay=???'
      },
      {
        id: 'headquarters1-video-major1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: '600 atommissiler<br>under isen',
        labelOffset: 110,
        horizontalLabelOffset: 0,
        // labelClasses: 'mod-texture-flip-x mod-texture-flip-y',
        yaw:  -0.5469416371396534,
        pitch: 0.05729628577011425,
        style: {
          width: '70px',
          height: '100px'
        },
        path: '/pano/headquarters1?overlay=headquarters1-video-major1'
      },
      {
        id: 'headquarters1-video-major2',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Hvad vil<br>Danmark sige?',
        labelOffset: 109,
        horizontalLabelOffset: 140,
        // labelClasses: 'mod-texture-flip-x mod-texture-flip-y',
        yaw:  -0.5469416371396534,
        pitch: 0.05729628577011425,
        style: {
          width: '50px',
          height: '100px'
        },
        path: '/pano/headquarters1?overlay=headquarters1-video-major2'

      },
      {

        id: 'headquarters1-document-report1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'document',
        text: 'Danmarks reaktion - analyse',
        labelOffset: -10,
        // labelClasses: 'mod-texture-flip-x mod-texture-flip-y',
        yaw: -0.49876202861399577,
        pitch: 0.39644552910559483,
        style: {
          width: '50px',
          height: '30px'
        },
         path: '/pano/headquarters1?overlay=headquarters1-analysis'
      },
    ]
  },
  {
    id: 'headquarters2',
    source: require('panorama/images/08-headquarters-02.jpg'),
    // preload: ['headquarters1'],
    orientation: {
      fov: 1.127117024737278,
      yaw: -0.9758102854269612,
      pitch: 0.425739261799734
    },
    audio: [{
      id: 'hq-audio',
      src: require('panorama/audio/hq.mp3')
    }],
    hotspots: [
      {
        id: 'headquarters2-nav-headquarters1-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: '',
        yaw: 3.086285208359035,
        pitch: 0.34,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -3.0034776909748384,
            pitch: 0.05985280472337884,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/headquarters1?y=-2.6664640280412115')
          })
        }
      },
      {
        id: 'headquarters2-video-book',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'document',
        text: 'Project Iceworm',
        labelOffset: 0,
        // labelClasses: 'mod-texture-flip-x mod-texture-flip-y',
        yaw: -1.3231762868267936,
        pitch: 0.43665086225079364,
        style: {
          width: '50px',
          height: '50px'
        },
        path: '/pano/headquarters2?overlay=headquarters2-iceworm'
      }
    ]
  },
  {
    id: 'tunnel-doctor',
    source: require('panorama/images/09-tunnel-doctor.jpg'),
    // preload: ['tunnel-headquarters', 'tunnel-reactor'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 3.1377160185704227,
      pitch: -0.019024001916392308
    },
    audio: [{
      id: 'tunnel-audio',
      src: require('panorama/audio/tunnel-audio-01.mp3')
    }],
    hotspots: [
      {
        id: 'tunnel-doctor-nav-tunnel-headquarters-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Kommandocentral',
        yaw: 0.002917327230886002,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.002917327230886002,
            pitch: -0.013079644694412806,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-headquarters?y=-0.0017565423691685567')
          })
        }
      },
      {
        id: 'tunnel-doctor-nav-tunnel-reactor-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Reaktorrum',
        yaw: 3.1333221188288167,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.1364182219631775,
            pitch: -0.008624595678494273,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-reactor')
          })
        }
      },
      {
        id: 'tunnel-doctor-doctor',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Jack Vance<br>Militærlæge<br>Alder: 31<br>3 måneder i Camp Century<br>Mission: Sikre soldaternes helbred',
        labelOffset: 0,
        yaw: 2.74455669222435,
        pitch: 0.10743203644728936,
        style: {
          width: '60px',
          height: '160px'
        },
        path: '/pano/tunnel-doctor?overlay=tunnel-doctor-doctor'
      },
    ]
  },
  {
    id: 'tunnel-reactor',
    source: require('panorama/images/10-tunnel-reactor.jpg'),
    // preload: ['tunnel-doctor', 'tunnel-rails', 'reactor1'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 3.1377160185704227,
      pitch: -0.019024001916392308
    },
    onInit: function(viewer, scene, options = {}) {
      var state = this;
      let lastViewed = state.lastViewed.length - 2
      if (state.lastViewed[lastViewed] === "reactor1") {
        setTimeout(() => {
          m.route.set("/pano/tunnel-reactor?overlay=reactorroom-leave")
          m.redraw()
        }, 100)
      }
    },
    audio: [{
      id: 'tunnel-audio',
      src: require('panorama/audio/tunnel-audio-01.mp3')
    }],
    hotspots: [
      {
        id: 'tunnel-reactor-nav-tunnel-doctor-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Kommandocentral',
        yaw: 0.002917327230886002,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.002917327230886002,
            pitch: -0.013079644694412806,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-doctor?y=-0.0017565423691685567')
          })
        }
      },
      {
        id: 'tunnel-reactor-nav-tunnel-rails-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Camp Century Afslutning',
        yaw: 3.1333221188288167,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.1364182219631775,
            pitch: -0.008624595678494273,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-rails')
          })
        }
      },
      {
        id: 'tunnel-reactor-sign-reactor-locked-portal',
        template: require('panorama/components/Hotspot/templates/LockedHotspot').default,
        locked: false,
        text: 'Tunnel 5<br>Reaktorrum',
        yaw: -2.66291069101808,
        pitch: 0.04026858128199606,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -2.8020011103237223,
            pitch: -0.008084325686265714,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/reactor1')
          })
        }
      },
    ]
  },
  {
    id: 'reactor1',
    source: require('panorama/images/11-reactor-01.jpg'),
    // preload: ['tunnel-reactor', 'reactor2'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 0.422302183278056,
      pitch: 0.10835784758035771
    },
    onInit: function(viewer, scene, options = {}) {
      let state = this

      let lastViewed = state.lastViewed.length - 2
      if (state.lastViewed[lastViewed] === "tunnel-reactor") {
        setTimeout(() => {
          m.route.set("/pano/reactor1?overlay=reactorroom-entrance")
          m.redraw()
        }, 100)
      }
    },
    audio: [
      {
        id: 'reactor',
        src: require('panorama/audio/reactor.mp3')
      },
      // {
      //   id: 'geiger1',
      //   src: require('panorama/audio/geiger.mp3'),
      //   position: 0.016506825441329198
      // }
    ],
    hotspots: [
      {
        id: 'reactor1-nav-tunnel-reactor-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Udgang',
        yaw: -3.13855846652846,
        pitch: 0.05,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -3.13855846652846,
            pitch: -0.006052484819059956,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-reactor')
          })
        }
      },
      {
        id: 'reactor1-nav-reactor2-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        yaw: 0,
        pitch: 0.23,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.004897335318450047,
            pitch: 0.040638797894714673,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/reactor2')
          })
        }
      },
      {
        id: 'reactor1-tuk',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'document',
        text: 'Tuk Erik Jørgen-Jensen<br>Dansk agent for Forsvarets Efterretningstjeneste<br>Øgenavn: Manden uden skygge<br>Alder: 27<br>Mission: At observere og rapportere',
        labelOffset: 0,
        // labelClasses: 'mod-texture-flip-x mod-texture-flip-y',
        yaw: 1.1620986113838612,
        pitch: 0.047585442598979455,
        style: {
          width: '100px',
          height: '100px'
        },
        // path: '/pano/reactor1?overlay=???'
      },
      {
        id: 'reactor1-video-erik1',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Strålingen',
        labelOffset: 90,
        horizontalLabelOffset: 5,
        yaw: 1.1620986113838612,
        pitch: 0.047585442598979455,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/reactor1?overlay=reactor1-video-erik1'
      },
      {
        id: 'reactor1-video-erik2',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Amerikansk pres for atomkraft',
        labelOffset: 89,
        horizontalLabelOffset: 130,
        yaw: 1.1620986113838612,
        pitch: 0.047585442598979455,
        style: {
          width: '100px',
          height: '100px'
        },
        path: '/pano/reactor1?overlay=reactor1-video-erik2'
      },
      {
        id: 'reactor1-reactor',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Reaktorkernen',
        yaw: 0.003810115408933612,
        pitch: 1.0159653522907188,
        style: {
          width: '200px',
          height: '200px'
        },
        path: '/pano/reactor1?overlay=reactor1-reactor'
      },
    ]
  },
  {
    id: 'reactor2',
    source: require('panorama/images/11-reactor-02.jpg'),
    // preload: ['reactor1'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 3.134159359966474,
      pitch: 0.04420561042514848
    },
    audio: [
      {
        id: 'reactor',
        src: require('panorama/audio/reactor.mp3')
      },
      // {
      //   id: 'geiger2',
      //   src: require('panorama/audio/geiger.mp3'),
      //   position: -0.0009947698448229403
      // }
    ],
    hotspots: [
      {
        id: 'reactor2-nav-reactor1-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        yaw: 0.005670073617563887,
        pitch: 0.44,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.0006740126673552282,
            pitch: 0.022107300277220077,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/reactor1?y=3.14')
          })
        }
      },
      {
        id: 'reactor2-general',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Joseph Freeman<br/>General og ingeniør, den amerikanske hær<br/>Alder: 40<br/>Mission: At lede Camp Century',
        labelOffset: 30,
        // labelClasses: 'mod-texture-flip-x mod-texture-flip-y',
        yaw: 2.5816066684484227,
        pitch: 0.17121972966336656,
        style: {
          width: '100px',
          height: '365px'
        },
        path: '/pano/reactor2?overlay=reactor2-general'
      }
    ]
  },
  {
    id: 'tunnel-rails',
    source: require('panorama/images/12-tunnel-rails.jpg'),
    // preload: ['tunnel-reactor', 'tunnel-exit', 'rails1'],
    orientation: {
      fov: 1.127117024737278,
      yaw: -2.8249451280379816,
      pitch: 0.07038807401806935
    },
    onInit: function(viewer, scene, options = {}) {
      var state = this;
      let lastViewed = state.lastViewed.length - 2
      if (state.lastViewed[lastViewed] === "rails1") {
        setTimeout(() => {
          m.route.set("/pano/tunnel-rails?overlay=railway-leave")
          m.redraw()
        }, 100)
      }
    },
    audio: [{
      id: 'tunnel-audio',
      src: require('panorama/audio/tunnel-audio-01.mp3')
    }],
    hotspots: [
      {
        id: 'tunnel-rails-nav-tunnel-reactor-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Reaktorrum',
        yaw: 0.002917327230886002,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.002917327230886002,
            pitch: -0.013079644694412806,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-reactor?y=-0.0017565423691685567')
          })
        }
      },
      {
        id: 'tunnel-rails-nav-tunnel-exit-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Udgang',
        yaw: 3.1333221188288167,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 3.1364182219631775,
            pitch: -0.008624595678494273,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-exit')
          })
        }
      },
      {
        id: 'tunnel-rails-sign-rails-locked-portal',
        template: require('panorama/components/Hotspot/templates/LockedHotspot').default,
        locked: false,
        text: 'Hemmelig tunnel<br>Jernbanespor',
        yaw: -1.9971027030353063,
        pitch: 0.002785149061089953,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -2.2852075177520454,
            pitch: -0.039576901544236875,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/rails1')
          })
        }
      },
    ]
  },
  {
    id: 'rails1',
    source: require('panorama/images/13-rails-01.jpg'),
    // preload: ['tunnel-rails', 'rails2'],
    orientation: {
      fov: 1.127117024737278,
      yaw: -2.8408985090955117,
      pitch: 0.13374158745614295
    },onInit: function(viewer, scene, options = {}) {
      let state = this
        setTimeout(() => {
          m.route.set("/pano/rails1?overlay=railway-entrance")
          m.redraw()
        }, 100)

    },
    audio: [{
      id: 'rails-audio',
      src: require('panorama/audio/rails.mp3')
    }],
    hotspots: [
      {
        id: 'rails1-nav-tunnel-rails-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Udgang',
        yaw: -2.763182027629039,
        pitch: 0.3,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: -2.7607115454113504,
            pitch: 0.003496953486497034,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-rails?y=0.010300165166251318')
          })
        }
      },
      // {
      //   id: 'rails1-nav-rails2',
      //   template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
      //   text: '',
      //   yaw: 0.0005390584556508315,
      //   pitch: 0.35,
      //   click: (viewer, scene) => {
      //     transitionFunction(scene, {
      //       yaw: 0.00891163165002773,
      //       pitch: 0.08677837809212541,
      //       fov: 0.5
      //     }).then(() => {
      //       m.route.set('/pano/rails2')
      //     })
      //   }
      // },
      {
        id: 'rails1-video-tuk',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'Tuk Erik Jørgen-Jensen<br>Dansk agent for Forsvarets Efterretningstjeneste<br>Øgenavn: Manden uden skygge<br>Alder: 27<br>Mission: At observere og rapportere',
        labelOffset: 30,
        yaw: -2.245427372949255,
        pitch: 0.2265434997879325,
        style: {
          width: '100px',
          height: '300px'
        },
         path: '/pano/rails1?overlay=rails1-video-tuk'
      },
      {
        id: 'rails1-video-william',
        template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
        icon: 'video',
        text: 'William Walker<br>Journalist ved Saturday Evening Post<br>Mission: At formidle til offentligheden',
        labelOffset: 30,
        yaw: 3.039808878200433,
        pitch: 0.11081819893476741,
        style: {
          width: '100px',
          height: '200px'
        },
        path: '/pano/rails1?overlay=rails1-video-william'
      },
    ]
  },
  // {
  //   id: 'rails2',
  //   source: require('panorama/images/13-rails-02.jpg'),
  //   // preload: ['rails1'],
  //   orientation: {
  //     fov: 3.023149311326886,
  //     yaw: 0.07595645742181567,
  //     pitch: 0.1383623354119674
  //   },
  //   audio: [{
  //     id: 'rails-audio',
  //     src: require('panorama/audio/rails.mp3')
  //   }],
  //   hotspots: [
  //     {
  //       id: 'rails2-nav-rails1',
  //       template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
  //       text: '',
  //       yaw: -3.1398540741873173,
  //       pitch: 0.3,
  //       click: (viewer, scene) => {
  //         transitionFunction(scene, {
  //     fov: 3.023149311326886,
  //     yaw: 0.07595645742181567,
  //           fov: 0.5
  //         }).then(() => {
  //           m.route.set('/pano/rails1')
  //         })
  //       }
  //     },
  //     {
  //       id: 'rails2-video-william',
  //       template: require('panorama/components/Hotspot/templates/PopupHotspot').default,
  //       icon: 'video',
  //       text: 'William Walker<br>Journalist ved Saturday Evening Post<br>Mission: At formidle til offentligheden',
  //       labelOffset: 30,
  //       fov: 3.023149311326886,
  //       yaw: 0.07595645742181567,
  //       style: {
  //         width: '100px',
  //         height: '200px'
  //       },
  //       path: '/pano/rails2?overlay=rails2-video-william'
  //     },
  //   ]
  // },
  {
    id: 'tunnel-exit',
    source: require('panorama/images/14-tunnel-exit.jpg'),
    // preload: ['tunnel-rails'],
    orientation: {
      fov: 1.127117024737278,
      yaw: 3.1377160185704227,
      pitch: -0.019024001916392308
    },
    onInit: function(viewer, scene, options = {}) {
      // On loading this scene, check the array of previously visited scenes.
      // If the list includes reactor1 & rails1, set the unlockHQ value to true.
      let state = this

      if (state.viewedScenes.includes("headquarters1")) {
        // console.log("You have been to the Reactor and Rails.")
        viewer.unlockHQ = true
        scene.hotspots[1].locked = false
        scene.hotspots[1].text = 'Tilbage til nutiden'
      } else {
        // console.log("You have not been to the Reactor and Rails.")
        viewer.unlockHQ = false
      }
    },
    audio: [{
      id: 'tunnel-audio',
      src: require('panorama/audio/tunnel-audio-01.mp3')
    }],

    hotspots: [
      {
        id: 'tunnel-exit-nav-tunnel-rails-locked-portal',
        template: require('panorama/components/Hotspot/templates/PortalHotspot').default,
        text: 'Jernbanespor',
        yaw: 0.002917327230886002,
        pitch: 0.15,
        click: (viewer, scene) => {
          transitionFunction(scene, {
            yaw: 0.002917327230886002,
            pitch: -0.013079644694412806,
            fov: 0.5
          }).then(() => {
            m.route.set('/pano/tunnel-rails?y=-0.0017565423691685567')
          })
        }
      },
      {
        id: 'tunnel-exit-note-locked-portal',
        template: require('panorama/components/Hotspot/templates/LockedHotspot').default,
        locked: false,
        text: 'Tilbage til<br> nutiden',
        yaw: 3.093555624358352,
        pitch: -0.017545312470625518,
        locked: true,
        style: {
          width: '100px',
          height: '200px'
        },
        click: (viewer, scene, options) => {
          // On click, check the unlockHQ value. If true, change the scene.
          if (viewer.unlockHQ === true) {
            m.route.set('/pano/tunnel-exit?overlay=end-unlocked-note')
          } else {
            m.route.set('/pano/tunnel-exit?overlay=end-locked-note')
          }
        }
      },
    ]
  },
]
